import React, { useState } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import FullScreenLoadingView from "presentational/common/FullScreenLoadingView";
import TXT from "presentational/common/multinational/TXT";
import { getDeviceType } from "lib/deviceInfo";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const fontCss = config.css.fontThickness;
const colorCss = config.css.color;
const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const SELECTED_FONT_SIZE_OFFSET_PX = 2;

const css = {
  root: { display: "flex", gap: 20 },
  baseButton: {
    flex: 1,
    height: 56,
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontSize:
      getDeviceType() === "mobile"
        ? mobileCss.fontSizeOfTextBtn
        : desktopCss.fontSizeOfTextBtn,
    fontWeight: fontCss.medium
  },
  unselected: {
    backgroundColor: colorCss.backgroundColorOfUnselectContainedButton,
    color: colorCss.colorOfUnselectContainedButton
  },
  selected: {
    backgroundColor: colorCss.backgroundColorOfHighlightContainedButton,
    color: colorCss.colorOfHighlightContainedButton,
    fontSize:
      getDeviceType() === "mobile"
        ? mobileCss.fontSizeOfTextBtn + SELECTED_FONT_SIZE_OFFSET_PX
        : desktopCss.fontSizeOfTextBtn + SELECTED_FONT_SIZE_OFFSET_PX
  }
};

GenderFillModalView.propTypes = {
  needGenderFillModal: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired
};

function GenderFillModalView(props) {
  const { needGenderFillModal, onSubmit } = props;
  const [selectedGender, setSelectedGender] = useState(null);
  const [open, setOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleGenderSelect = gender => () => {
    setSelectedGender(gender);
  };

  const handleSubmitClick = async () => {
    setIsLoading(true);
    await onSubmit(selectedGender);
    /** 일부러 모달 사라지기전 로딩 풀려서 화면 빤짝거리는 문제 해결위해 주석처리 */
    // setIsLoading(false);
    setOpen(false);
  };

  const getComponent = () => {
    return (
      <div style={css.root}>
        <button
          style={{
            ...css.baseButton,
            ...(selectedGender === "female" ? css.selected : css.unselected)
          }}
          onClick={handleGenderSelect("female")}
        >
          <TXT name="wordSexUserInfo_female" />
        </button>
        <button
          style={{
            ...css.baseButton,
            ...(selectedGender === "male" ? css.selected : css.unselected)
          }}
          onClick={handleGenderSelect("male")}
        >
          <TXT name="wordSexUserInfo_male" />
        </button>
        {isLoading && <FullScreenLoadingView />}
      </div>
    );
  };

  return (
    <CommonModalView
      open={needGenderFillModal && open}
      onClose={() => {}}
      paperStyle={{ width: "100%", maxWidth: 500 }}
      titleText={<TXT name="titleModal_chooseYourGender" />}
      contentComponent={getComponent()}
      firstButtonText={<TXT name="btnModal_submit" />}
      firstButtonFunc={handleSubmitClick}
      firstButtonDisabled={!selectedGender}
    />
  );
}

export default GenderFillModalView;
